import { v4 as uuid } from "uuid";
import { z } from "zod";
export const financialLineItemSchema = z.object({
    estimatedACTHours: z.number().optional(),
    estimatedBepHoursManagement: z.number().optional(),
    estimatedBepHoursNonTrade: z.number().optional(),
    estimatedBepHoursTrade: z.number().optional(),
    estimatedTotalWorkHours: z.number().optional(),
    id: z.string(),
    totalValue: z.number().optional()
});
export const createDefaultFinancial = () => financialLineItemSchema.parse({
    id: uuid()
});
